import { DataLlave } from "../../bussines/entities/EstadisticasLlave.entity";

export class DataLlaveModel implements DataLlave {
    constructor(
        public ruc: string,
        public razonSocial: string,
        public documento: string,
        public codactivacion: string,
        public producto: string,
        public fechaExpiracion: Date
    ) { }

    serialize(): DataLlave {
        return {
            ruc: this.ruc,
            razonSocial: this.razonSocial,
            documento: this.documento,
            codactivacion: this.codactivacion,
            producto: this.producto,
            fechaExpiracion: this.fechaExpiracion
        }
    }

    static deserialize(entity: DataLlave): DataLlaveModel {
        return new DataLlaveModel(
            entity.ruc ?? '',
            entity.razonSocial ?? '',
            entity.documento ?? '',
            entity.codactivacion ?? '',
            entity.producto ?? '',
            entity.fechaExpiracion ?? ''
        );
    }
}